import { ILink, IPageProperties, ImgPos, StrokeSelection, Theme } from "@/types/types"
import { ICampaignBanner } from "@/types/ICampaignBanner";
import { IContentBanner } from "@/types/IContentBanner";
import { ILatestNewsComponent } from "@/types/ILatestNewsComponent";
import { IRichTextComponent } from "@/types/IRichTextComponent";
import { IQuoteComponent } from "@/types/IQuoteComponent";
import { IContactListComponent } from "@/types/IContactListComponent";
import { IListComponent } from "@/types/IListComponent";
import { IFrontPageProperties } from "@/types/IFrontPage";
import { IGlobalNavItem,  INavDropdowItem, INavListItem } from "@/types/INavigation";
import { IImageModuleComponent } from "@/types/IImageModuleComponent";
import { IDataComponent } from "@/types/IDataComponent";


import { ICampaignComponentProps } from "@/types/components/ICampaignProps";
import { IContentBannerComponentProps } from "@/types/components/IContentBannerProps";
import { ILatestNewsComponentProps } from "@/types/components/ILatestNewsProps";
import { IContactListComponentProps } from "@/types/components/IContactListProps";
import { IListComponentProps } from "@/types/components/IListProps";
import { IQuoteComponentProps } from "@/types/components/IQuoteProps";
import { IRichTextComponentProps } from "@/types/components/IRichTextProps";
import { IFooterProps } from "@/types/components/IFooterProps";
import { IDropdownLink, INavLink, INavigationProps } from "@/types/components/INavigationProps";
import { IImageModuleComponentProps } from "@/types/components/IImageModuleProps";
import { IDataComponentProps} from "@/types/components/IDataComponentProps";



import Quote from "@atoms/Quote/Quote.ce.vue";
import RichtextEditor from "@atoms/RichTextEditor/RichTextEditor.ce.vue";
import CampaignModule from "@molecules/CampaignModule/CampaignModule.ce.vue"
import ContentBanner from "@molecules/ContentBanner/ContentBanner.ce.vue"
import ContactListModule from "@molecules/ContactListModule/ContactListModule.ce.vue";
import ExpertModule from "@molecules/ExpertModule/ExpertModule.ce.vue";
import ListModule from "@organisms/List/List.ce.vue";
import NewsCardSection from "@organisms/NewsCardSection/NewsCardSection.ce.vue"
import ImageModule from "@molecules/ImageModule/ImageModule.ce.vue";
import DataComponent from "@molecules/DataComponent/DataComponent.ce.vue";
import Accordion from "@molecules/Accordion/Accordion.ce.vue";
import Map from "@molecules/Map/Map.ce.vue";
import RelatedProjects from "@organisms/RelatedProjects/RelatedProjects.ce.vue";
import RelatedPagesModule  from "@organisms/RelatedPagesModule/RelatedPagesModule.ce.vue";
import TestimonialComponent from "@molecules/TestimonialComponent/TestimonialComponent.ce.vue";
import VideoComponent from "@molecules/VideoComponent/VideoComponent.ce.vue";
import TimeLine from "@organisms/TimeLine/TimeLine.ce.vue";
import Table from "@molecules/Table/Table.ce.vue"
import Employees from "@molecules/Employees/Employees.ce.vue"
import RegionalExpertModule from "@molecules/RegionalExpertModule/RegionalExpertModule.ce.vue"

import { formatDate } from "./helper";
import {
  ComponentType,
  NavLinkType,
  ThemeColor
} from "@/util/constants";
import { IExpertComponent } from "@/types/IExpertComponent";
import { IExpertComponentProps } from "@/types/components/IExpertModuleProps";
import { IAccordionComponent } from "@/types/IAccordionComponent";
import { IAccordionComponentProps } from "@/types/components/IAccordionProps";
import { IMapComponent } from "@/types/IMapComponent";
import { IMapComponentProps } from "@/types/components/IMapComponentProps";
import { IRelatedProjectsComponent } from "@/types/IRelatedProjectComponent";
import { IRelatedProjectsComponentProps } from "@/types/components/IRelatedProjectProps";
import { IRelatedPagesComponent } from "@/types/IRelatedPagesComponent";
import { IRelatedPagesComponentProps } from "@/types/components/IRelatedPagesProps";
import { ITestimonialComponent } from "@/types/ITestimonialComponent";
import { IVideoComponent } from "@/types/IVideoComponent";
import { ITestimonialComponentProps } from "@/types/components/ITestimonialComponentProps";
import { ITimeLineComponent, ITimelineItem } from "@/types/ITimelineComponent";
import { ITimelineComponentProps } from "@/types/components/ITimeLineProps";
import { IVideoComponentProps } from "@/types/components/IVideoComponentProps";
import { ITableComponent } from "@/types/ITableComponent";
import { ITabletComponentProps } from "@/types/components/ITableProps";
import { IEmployeesComponent } from "@/types/IEmployeesComponent";
import { IEmployeesComponentProps } from "@/types/components/IEmployeesProps"; 
import { IRegionalExpertComponent } from "@/types/IRegionalExpertComponent";
import { IRegionalExpertComponentProps } from "@/types/components/IRegionalExpertModuleProps";
import { getNews} from "./api";


export interface INavAndFooter {
  navigation: INavigationProps,
  footer:  IFooterProps
}

export function getNavAndFooter(properties: IFrontPageProperties | IPageProperties):INavAndFooter {
  const {address, addressHeader, email, footerLinkColumns, phone, socialMediaLinks, globalNavigation, globalServiceNavigation, searchPage, searchPlaceholder, subsite} = properties;
  const globalServiceNavLinks = globalServiceNavigation?.map(link => ({    
    name: link.title,
    url: link.route.path,
  })) || [];


  const globalNavLinks: (IDropdownLink | INavLink)[] = globalNavigation?.items.reduce((acc, link: IGlobalNavItem) => {
    const { content } = link;
    
    if (content?.contentType === NavLinkType.DROPDOWN && 'properties' in content && content.properties) {
      const linkType = content.contentType as NavLinkType;
      const data = content.properties as INavDropdowItem;
      const links = data.navigationLinks.map(link => ({
        name: link.title,
        url: link.route.path,
        target: link.target,
      }));
      
      acc.push({
        linkType,
        name: data.title,
        links: links,
      });
    } else if (content?.contentType === NavLinkType.LINK && 'properties' in content && content.properties) {
      const data = content.properties as INavListItem;
      const linkType = content.contentType as NavLinkType;
      if (data.navigationLink && data.navigationLink.length > 0) {
        acc.push({
          linkType,
          name: data.navigationLink[0].title,
          url: data.navigationLink[0].route.path,
        });
      }
    }
    return acc;
  }, [] as (IDropdownLink | INavLink)[]) || [];
  return {
    footer:{
      phone,
      email,
      addressHeader,
      address : address?.markup,
      footerLinkColumns: footerLinkColumns,
      socialMediaLinks: socialMediaLinks,
      subsite: subsite,
    },
    navigation: {
      globalNavLinks: globalNavLinks,
      globalServiceNavLinks,
      searchFieldLabel: searchPlaceholder,
      searchPageUrl: searchPage[0].route ? searchPage[0].route.path : "",
      subsite: subsite,
    }
  }
}

export function getStroke(background: string, stroke: StrokeSelection | null) {
  if (!stroke) return;
  if(background === ThemeColor.AUBERGINE){
    return stroke.aubergineSelected?.label
  }
  if(background === ThemeColor.OCEAN){
    return stroke.oceanSelected?.label
  }
  if(background === ThemeColor.GRASS){
    return stroke.grassSelected?.label
  }
  else{
    return stroke.lightSelected?.label
  } 
}

export function getLink(link: ILink[] | undefined) {
  if (!link || !link[0]) return;  
  return {
    title: link[0].title,
    url: link[0].route ? link[0].route.path : link[0].url,
    target: link[0].target,
  };
}

export const getComponent = (name: ComponentType) => {  
  // console.log('name: ', name)
  switch (name) {
    case ComponentType.CONTENT_BANNER:
      return ContentBanner
    case ComponentType.CAMPAIGN_BANNER:
      return CampaignModule
    case ComponentType.LATEST_NEWS:
      return NewsCardSection
    case ComponentType.CONTACT_LIST:
      return ContactListModule
    case ComponentType.LIST_COMPONENT:
      return ListModule
    case ComponentType.QUOTE:
      return Quote
    case ComponentType.RICH_TEXT_COMPONENT:
      return RichtextEditor
    case ComponentType.IMAGE_MODULE:
      return ImageModule
    case ComponentType.DATA_COMPONENT:
      return DataComponent
    case ComponentType.EXPERT_COMPONENT:
      return ExpertModule
    case ComponentType.ACCORDION_COMPONENT:
      return Accordion
    case ComponentType.MAP_COMPONENT:
      return Map
    case ComponentType.RELATED_PROJECTS:
      return RelatedProjects
    case ComponentType.RELATED_PAGES:
      return RelatedPagesModule
    case ComponentType.TESTIMONIAL_COMPONENT:
      return TestimonialComponent
    case ComponentType.TIMELINE_COMPONENT :
      return TimeLine
    case ComponentType.VIDEO_COMPONENT:
      return VideoComponent
    case ComponentType.TABLE:
      return Table
    case ComponentType.EMPLOYEES:
      return Employees
    case ComponentType.REGIONAL_EXPERT_COMPONENT:
      return RegionalExpertModule
    
  }
}

export const getComponentData = (
  content: 
    IContentBanner 
    | ICampaignBanner 
    | ILatestNewsComponent 
    | IContactListComponent
    | IListComponent
    | IQuoteComponent
    | IRichTextComponent
    | IDataComponent
    | IRichTextComponent
    | IImageModuleComponent
    | IExpertComponent
    | IAccordionComponent
    | IMapComponent
    | IRelatedProjectsComponent
    | IRelatedPagesComponent
    | ITestimonialComponent
    | ITimeLineComponent
    | IVideoComponent
    | ITableComponent
    | IEmployeesComponent
    | IRegionalExpertComponent,	
    theme?: Theme | null
  ): 
    IContentBannerComponentProps 
    | ICampaignComponentProps 
    | ILatestNewsComponentProps 
    | IContactListComponentProps 
    | IListComponentProps
    | IQuoteComponentProps
    | IRichTextComponentProps
    | IDataComponentProps
    | IImageModuleComponentProps
    | IExpertComponentProps
    | IAccordionComponentProps
    | IMapComponentProps
    | IRelatedProjectsComponentProps
    | IRelatedPagesComponentProps
    | ITestimonialComponentProps
    | ITimelineComponentProps
    | IVideoComponentProps
    | ITabletComponentProps
    | IEmployeesComponentProps
    | IRegionalExpertComponentProps
    | undefined => {
  if (!content) return;


  const commonProcessing = (content: IContentBanner | ICampaignBanner) => {
    const {properties} = content;    
    const link = getLink(properties.link);
    const stroke = {
      lightSelected: properties.lightSelected,
      oceanSelected: properties.oceanSelected,
      aubergineSelected: properties.aubergineSelected,
      grassSelected: properties.grassSelected,
    };

    const portrait = content.contentType === ComponentType.CONTENT_BANNER && content.properties.imageDirection === "Portrait" ? true : false;
    

    const image = 
      content.contentType === ComponentType.CAMPAIGN_BANNER ? content.properties.image[0] :
      content.contentType === ComponentType.CONTENT_BANNER && portrait ? content.properties.contentBannerPortrait ? content.properties.contentBannerPortrait[0]:""
      : content.properties.contentBannerLandscape ? content.properties.contentBannerLandscape[0] : "";
      let text: string | undefined;

      if (content.contentType === ComponentType.CAMPAIGN_BANNER && 'content' in properties) {
        // Now TypeScript knows properties must be ICampaignBannerProperties
        text = properties.content?.markup;
      } else if (content.contentType=== ComponentType.CONTENT_BANNER && 'description' in properties) {
        // Now TypeScript knows properties must be IContentBannerProperties
        text = properties.description?.markup;
      }
    const imageJson = JSON.stringify(image);
        return {
      name: content.contentType,
      props: {
        theme: properties.backgroundColor,
        title: properties.title,
        subtitle: properties.tag,
        text: text,
        ctaLabel: link ? link.title : undefined,
        ctaLink: link ? link.url : undefined,
        target: link ? link.url : undefined,
        imgPos: properties.imageAlignment ? "right" as ImgPos : "left" as ImgPos,
        stroke: getStroke(properties.backgroundColor, stroke),
        imgAlt: content.properties.imageAltText,
        videoId: content.properties.videoId,
        videoLoop: content.properties.videoLoop,        
        image: imageJson,
        portrait: portrait,
      },
    };
  };
  if (
    content.contentType === ComponentType.CAMPAIGN_BANNER || content.contentType === ComponentType.CONTENT_BANNER
    ) {
    return commonProcessing(content);
  }

  if (content.contentType === ComponentType.REGIONAL_EXPERT_COMPONENT) {
    const { properties } = content as IRegionalExpertComponent;
    const expertList = properties.expertList.map((expert) => {
     
      const region = expert.properties.expertRegion.length > 0 ?  expert.properties.expertRegion[0].properties.title :"";
      return {
        content: expert.properties.content?.markup,
        email: expert.properties.email,
        image: expert.properties.image ? JSON.stringify(expert.properties.image[0]) : "",
        imageAltText: expert.properties.imageAltText,
        jobDescription: expert.properties.jobDescription,
        phone: expert.properties.phone,
        title: expert.properties.title,
        exportRegion: region,
      }
    }
    )
    const expertsJson = JSON.stringify(expertList);
    
    return {
      name: content.contentType,
      props: {
        theme: properties.backgroundColor.label,
        expertList: expertsJson,
      }
    } as IRegionalExpertComponentProps;
  }

  if (content.contentType === ComponentType.EMPLOYEES) {
    const { properties } = content;
    // console.log("properties.showRegion: ", properties.showRegion)
    const employees = properties.employees.items.map((employee) => {
      const { content } = employee;
      const image = content.properties.image;
      const imageJson = image && JSON.stringify(image[0]);
      const region = content.properties?.employeeRegion &&  content.properties?.employeeRegion?.length > 0 ?  content.properties.employeeRegion[0].properties.title :"";
      return {
        name: content.properties.employee,
        position: content.properties.position,
        focusArea: content.properties.focusArea,
        image: imageJson,
        imageAltText: content.properties.imageAltText,
        description: content.properties.description ? content.properties.description.markup : undefined,
        speciality: content.properties.speciality,
        link: content?.properties?.link ? content?.properties?.link[0].url ? content?.properties?.link[0].url : content?.properties?.link[0].route.path : null,
        employeeRegion: region,
      };
    });
    const employeesJson = JSON.stringify(employees);
    return {
      name: content.contentType,
      props: {
        theme: properties.backgroundColor.label,
        title: properties.title,
        employees: employeesJson,
        showRegion: properties.showRegion,
      },
      
    } as IEmployeesComponentProps;
    
  }

  if(content.contentType === ComponentType.LATEST_NEWS) {
    const {properties} = content;    
    
    const cards = properties?.newsItems?.map((item) => {      
      const isHorizontal = properties.newsItems.length > 1 
      return {
        image: JSON.stringify(item.properties.image[0]), 
        imgAlt: item.properties.imageAltText, 
        location: item.properties.newsRegion[0].name, 
        date: formatDate(item.properties.newsDate), 
        title: item.properties.title,
        isHorizontal,
        href: item.route.path,
        theme: properties.backgroundColor.label,
      }
    })
    const cardsJson = JSON.stringify(cards);
    return {
      name: content.contentType,
      props: {
        theme: properties.backgroundColor.label,
        title: properties.title,
        cards: cardsJson,
        ctaLabel: properties.seeAllLink && properties.seeAllLink[0].title,
        ctaLink: properties.seeAllLink && properties.seeAllLink[0].route.path,
        target: properties.seeAllLink && properties.seeAllLink[0].target 
      },
    } as ILatestNewsComponentProps;
  }

  if(content.contentType === ComponentType.CONTACT_LIST) {
    const { properties } = content;
    const contactList = properties.contactBlockList.items.map((item) => {        
      const image = item.content.properties.image ?  item.content.properties.image[0] : ''
      return {
        fullName: item.content.properties.fullName,
        jobPosition: item.content.properties.jobPosition,
        email: item.content.properties.email,
        country: item.content.properties.country,
        image: JSON.stringify(image),
        imageAltText: item.content.properties.imageAltText,
        phone: item.content.properties.phone,
        link: item.content?.properties?.link ? item.content?.properties?.link[0].url ? item.content?.properties?.link[0].url : item.content?.properties?.link[0].route.path : null,
        linkTitle: item.content?.properties?.link ? item.content?.properties?.link[0].title : null,
      }
     })
 
    const contactListJson = JSON.stringify(contactList);
    return {
      name: content.contentType as ComponentType,
      props: {
        theme: properties.backgroundColor.label,
        title: properties.title,
        contactList: contactListJson,  
      },
    } as IContactListComponentProps;
  }
  
  if (content.contentType === ComponentType.LIST_COMPONENT) {
    const {properties} = content;

    const list = properties?.lists?.items.map((item) => {
      const { content } = item;

      const links = content.properties?.list?.map((item) => {
        return {
          ctaLink: item.url,
          ctaLabel: item.title,
          linkType: item.linkType,
          target: item.target
        }
      })
      
      return {
        title: content.properties.title,
        description: content.properties.description ? content.properties.description.markup : undefined,
        list: links,
        theme: properties.backgroundColor.label
      }
    })

    const listJson = JSON.stringify(list); 

    return {
      name: content.contentType,
      props: {
        theme: properties.backgroundColor.label,
        title: properties.title,
        description: properties.description ? properties.description.markup : undefined,
        list: listJson,
      }

    } as IListComponentProps
  }

 if(content.contentType === ComponentType.QUOTE) {
  const { properties } = content as IQuoteComponent;
  const {quote, author, jobPosition} = properties;
  return {
    name: content.contentType,
    props: {
      author,
      profession: jobPosition,
      text: quote.markup,
      theme
    }
  } as IQuoteComponentProps
 }

 if (content.contentType === ComponentType.VIDEO_COMPONENT) {
  const {properties} = content as IVideoComponent;
  
  const {videoId, backgroundColor, videoLoop, videoSize, title, description} = properties;  
  return {
    name: content.contentType,
    props: {
      title,
      description: description && description.markup,
      videoId,
      videoLoop,
      theme: backgroundColor.label,
      videoSize,
    }
  } as IVideoComponentProps
 }

 if(content.contentType === ComponentType.TESTIMONIAL_COMPONENT) {
  const { properties } = content as ITestimonialComponent;
  const {author, jobDescription, description, image, imageAltText, backgroundColor} = properties;
  
  return {
    name: content.contentType,
    props: {
      author,
      description: description.markup,
      jobDescription,
      image: JSON.stringify(image),
      imageAltText,
      theme: backgroundColor.label
    }
  } as ITestimonialComponentProps
 }

 if(content.contentType === ComponentType.RICH_TEXT_COMPONENT) {
  const {properties} = content as IRichTextComponent;
  return {
    name: content.contentType,
    props: {
      content: properties.content.markup,
      theme
    }
  } as IRichTextComponentProps
 }
 if (content.contentType === ComponentType.DATA_COMPONENT) {
  const {properties} = content;  
  const numberLists =properties.numberList ? properties.numberList?.items?.map((item) => {
    return{
      title: item.content.properties.title,
      content: item.content.properties.content?.markup
    }    
  }) : null;
  const numberListJson = JSON.stringify(numberLists);
  
  const iconLists = properties.iconList ? properties.iconList?.items?.map((item) => {
    let itemIcon = item.content?.properties?.icon
    return{
      title: item.content.properties.title,
      content: item.content.properties.content?.markup,
      icon: itemIcon && itemIcon.length ? itemIcon[0]?.url : ''
    }
  }) : null;
  const iconListJson = JSON.stringify(iconLists);
  const moduleWidth = properties.componentWidth ? properties.componentWidth : "lg";

  return{
    name: content.contentType,
    props:{
      title: properties.title,
      text: properties.content?.markup,
      type: properties.dataListType,
      numberLists: numberListJson,
      iconList: iconListJson,
      theme: properties?.backgroundColor.label,   
      componentWidth: moduleWidth 
    }
  } as IDataComponentProps
 }

 if (content.contentType === ComponentType.IMAGE_MODULE) {
    const { properties } = content;    
    const image = properties.image[0];
    const imageJson = JSON.stringify(image);    
    return {
      name: content.contentType,
      props: {
        image: imageJson,
        imageAltText: properties.imageAltText,
        imageCaption: properties.imageCaption,
        imageCrop: properties.imageCrop,   },
    } as IImageModuleComponentProps;
  }
 if (content.contentType === ComponentType.EXPERT_COMPONENT) {
    const { properties } = content;  
    return {
      name: content.contentType,
      props: {
      theme: properties.backgroundColor.label,
      expert: JSON.stringify(properties.expert),
      subtitle: properties.tag,      
      } 
    } as IExpertComponentProps;
  }

 if (content.contentType === ComponentType.ACCORDION_COMPONENT) {
    const { properties } = content;
    let imageJson
    if(properties.image){
      const img = properties.image[0]
      imageJson = JSON.stringify(img); 
    }    
    const accordionList = properties.accordionList.items.map((item) => {
      return {
        title: item.content.properties.title ? item.content.properties.title : "",
        content: item.content.properties.content ? item.content.properties.content.markup : "",
      }
    })
    const accordionItemsJson = JSON.stringify(accordionList); 
    const moduleWidth = properties.componentWidth ? properties.componentWidth : "lg";   
    
    return {
      name: content.contentType,
      props: {
      theme: properties.backgroundColor.label,
      title: properties.title,
      tag: properties.tag,
      description: properties.content ? properties.content.markup : null,
      image: imageJson,
      imgAlt: properties.imageAltText || '',
      items: accordionItemsJson,
      videoId: properties.videoId,
      imgPos: properties.imageAlignment ? "right" as ImgPos : "left" as ImgPos,
      componentWidth: moduleWidth 
      } 
    } as IAccordionComponentProps;
  }
 if (content.contentType === ComponentType.MAP_COMPONENT) {
    const { properties } = content;
    return {
      name: content.contentType,
      props: {
      theme: properties.backgroundColor.label,
      title: properties.title,
      text: properties.description ? properties.description.markup :""
      
  
      } 
    } as IMapComponentProps;
  }
 if (content.contentType === ComponentType.RELATED_PROJECTS) {
    const { properties } = content;
    const projects  = properties.relatedProjects.map((p) => {
      return {
        title: p.properties.title,
        tag: p.properties.tag,
        country: p.properties.country,
        image:  p.properties.image && p.properties.image[0] ? JSON.stringify(p.properties.image[0]) : null ,
        imgAlt: p.properties.imageAltText,
        client:  p.properties.partners,
        url: p.route.path,
      }
      
    })
    return {
      name: content.contentType,
      props: {
        title: properties.title,
        theme: properties.backgroundColor.label, 
        ctaLabel: properties.seeAllLinks && properties.seeAllLinks[0].title,
        ctaLink: properties.seeAllLinks && properties.seeAllLinks[0].route.path,
        target: properties.seeAllLinks && properties.seeAllLinks[0].target, 
        projects: JSON.stringify(projects),
      } 
    } as IRelatedProjectsComponentProps;
  }

 if (content.contentType === ComponentType.RELATED_PAGES) {
    const { properties } = content;
    const relatedPages  = properties.relatedPages.items.map((p) => {
      const { content } = p;
      return {
        title: content.properties.title,
        image:  content.properties.image && JSON.stringify(content.properties.image[0]),
        imgAlt: content.properties.imageAltText,
        url: content.properties.link[0].route.path,
      }
      
    })
    return {
      name: content.contentType,
      props: {
        title: properties.title,
        theme: properties.backgroundColor.label, 
        pages: JSON.stringify(relatedPages),
      } 
    } as IRelatedPagesComponentProps;
  }

 if (content.contentType === ComponentType.TIMELINE_COMPONENT) {
    const { properties } = content;
    const years  = properties.timeline.items.reduce((acc: any, item: ITimelineItem ) => {
      const { content } = item;
      acc.push({
        year: content.properties.tag,
        title: content.properties.title,
        content: content.properties.content.markup,
        image: content.properties.image ? JSON.stringify(content.properties.image[0]) : "",
      })
      return acc;

    }, [])
    return {
      name: content.contentType,
      props: {
        title: properties.title,
        theme: properties.backgroundColor.label, 
        strokeColor: properties.stroke.label,
        years: JSON.stringify(years),
      } 
    } as ITimelineComponentProps;
  }
  if( content.contentType === ComponentType.TABLE){
    const { properties } = content;
    return {
      name: content.contentType,
      props: {
        title: properties.title,
        table: properties.table.markup, 
      } 
    } as ITabletComponentProps;
  }
}